// React Lib
import React, { useState } from "react";
import classnames from 'classnames';
import { CopyToClipboard as Copy } from 'react-copy-to-clipboard';
// Component Styles
import { useStyles } from "./UpAndRunningStyles";
// @otg-one/ui_components/components
import { Delete, Edit, ShowMoreVertical } from "../../sap_icons";
import { Typography, Radio, Button, Form, OverflowMenu } from "../index";
import { AddNote, CopyToClipboard } from "../../icons";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
const NoteRenderer = (props) => {
    const classes = useStyles(props);
    const { data, type, onEditNote, onSaveNote, onDeleteNote, onCopyNote, addNote, phaseNote, addPhaseNote, cancel, saveNote } = props;
    const [notes, setNotes] = useState(data.notes);
    const handleChangeNoteTemporarily = e => {
        setNotes(e.target.value);
    };
    const handleOnSaveNote = () => {
        const noteEl = document.getElementById(`${data.id}-note-input`);
        if (noteEl) {
            onSaveNote(data, type, noteEl.value);
        }
    };
    return (React.createElement(React.Fragment, null,
        (!data.isEditMode && data.notes.length === 0) && (React.createElement(Button, { type: "secondary", color: 'blue', alignIcon: "right", icon: React.createElement(AddNote, { style: { width: 24, height: 24, color: Color.primary[500] } }), onClick: onEditNote(data, type) }, addNote)),
        (!data.isEditMode && data.notes.length > 0) && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 12, color: Color.neutral[600], style: { marginTop: 18 } }, { phaseNote } + ' :'),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR_ITALIC, size: 12, color: Color.neutral[400], style: { marginTop: 3, lineHeight: 1.8 } }, data.notes),
            React.createElement("div", { className: classes.functionBoxCollectionNoteActionsContainer },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement(Edit, { style: { color: Color.primary[200], cursor: 'pointer' }, onClick: onEditNote(data, type) }),
                    React.createElement(Copy, { onCopy: onCopyNote, text: data.notes },
                        React.createElement(CopyToClipboard, { id: `${data.id}-copy-note-button`, style: { color: Color.primary[200], marginLeft: 18, cursor: 'pointer' } }))),
                React.createElement(Delete, { style: { color: Color.danger[300], marginLeft: 18, cursor: 'pointer' }, onClick: onDeleteNote(data, type) })))),
        data.isEditMode && (React.createElement(React.Fragment, null,
            React.createElement(Form, { id: `${data.id}-note-input`, color: "white", multiline: true, placeholder: addPhaseNote, value: notes, onChange: handleChangeNoteTemporarily }),
            React.createElement("div", { className: classes.functionCollectionNoteActionsContainer },
                React.createElement(Button, { type: "tertiary", color: 'blue', onClick: onEditNote(data, type) }, cancel),
                React.createElement(Button, { type: "tertiary", color: 'blue', onClick: handleOnSaveNote }, saveNote))))));
};
export const UpAndRunning = (props) => {
    const classes = useStyles(props);
    const { data, isDragging, children, hasChild, onEditNote, onSaveNote, onDeleteNote, onCopyNote, onTimelineChange, addNote, phaseNote, addPhaseNote, cancel, saveNote, noFunctionAssigned, dragAndDropAFunctionHere, menuItem, onEdit, onDelete, style } = props;
    const upAndRunningClasses = classnames({
        [classes.upAndRunningContainer]: !isDragging,
        [classes.upAndRunningContainerIsDraggingOver]: isDragging
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();
        if (!anchorEl) {
            setAnchorEl(event.currentTarget);
        }
    };
    return (React.createElement("div", { id: data.id, className: upAndRunningClasses, style: style },
        React.createElement(ShowMoreVertical, { style: {
                position: 'absolute',
                top: 16, right: 10,
                width: 24, height: 24,
                color: Color.primary[200],
                cursor: 'pointer'
            }, onClick: handleClickShowMoreIcon }),
        React.createElement(OverflowMenu, { anchorElement: anchorEl, setAnchorEl: setAnchorEl, 
            // menuItems={menuItem}
            menuItems: [
                {
                    text: "Phase bearbeiten",
                    onClick: () => onEdit()
                },
                {
                    text: "Phase löschen",
                    onClick: () => onDelete()
                }
            ] }),
        React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 14, color: Color.neutral[600], style: { paddingBottom: 20 } }, data.name),
        children,
        React.createElement("div", { style: {
                width: '100%',
                paddingTop: 15,
                paddingBottom: 25,
                textAlign: 'center'
            } },
            !hasChild && (React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[400], style: { paddingBottom: 5 } }, noFunctionAssigned)),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 12, color: Color.neutral[400] }, dragAndDropAFunctionHere)),
        React.createElement("div", { className: classes.timelineInputContainer }, data.timeline.map((time, index) => (React.createElement(Radio, { name: data.id, value: time, label: time, checked: data.selectedTimeline === time, onChange: onTimelineChange, style: { marginRight: index === 0 ? 30 : 'auto' } })))),
        React.createElement(NoteRenderer, { data: data, type: "UP_AND_RUNNING", onEditNote: onEditNote, onSaveNote: onSaveNote, onDeleteNote: onDeleteNote, onCopyNote: onCopyNote, addNote: addNote, phaseNote: phaseNote, addPhaseNote: addPhaseNote, cancel: cancel, saveNote: saveNote })));
};
UpAndRunning.defaultProps = {
    data: {
        id: "up-running-1",
        name: "Up and Running #",
        timeline: [90, 120],
        selectedTimeline: 90,
        isEditMode: false,
        notes: ""
    },
    isDraggingOver: false,
    children: null,
    isDragging: false,
    hasChild: false,
    addNote: 'Add Note',
    phaseNote: 'Phase Note',
    addPhaseNote: 'Add Phase Note',
    cancel: 'Cancel',
    saveNote: 'Save Note',
    editPhase: 'Edit Phase',
    deletePhase: 'Delete Phase',
    noFunctionAssigned: 'No Function Assigned',
    dragAndDropAFunctionHere: 'Drag And Drop A Function Here',
    menuItem: [{
            text: 'Edit Phase',
            onClick: () => { }
        },
        {
            text: 'Delete Phase',
            onClick: () => { }
        }],
    onEditNote: () => { }
};
export default React.memo(UpAndRunning);
